

























import Vue from 'vue';
import { mapActions } from 'vuex';
import moment from 'moment';

import { IQuote, Quote } from '@/models/quote';
import { ISystemError } from '@/models/error';

import { createPdf, setErrorFromAxiosError } from '@/utils/helpers';

import QuoteLanguageSelector from './QuoteLanguageSelector.vue';

export default Vue.extend({
  name: 'QuotePDFDialog',

  components: { QuoteLanguageSelector },

  data: () => ({
    dialog: false,
    loading: false,
    error: null as ISystemError | null,
    quote: null as null | IQuote
  }),

  methods: {
    ...mapActions({
      exportQuoteProposal: 'quote/exportQuoteProposal'
    }),

    open(quote: Quote) {
      this.dialog = true;
      this.quote = quote;
      this.clearAllErrors();
    },

    close() {
      this.dialog = false;
    },

    clearAllErrors(): void {
      this.error = null;
    },

    generatePdf(language: string) {
      this.clearAllErrors();
      this.loading = true;
      this.exportQuoteProposal({
        quoteId: this.quote!.number,
        language: language
      })
        .then((data: Blob) => {
          createPdf(
            data,
            `${this.quote!.number!}-quote-proposal-${moment(new Date()).format(
              'YYYY-MM-DD-HH-mm-ss'
            )}.pdf`
          );
          this.close();
        })
        .catch(responseError => {
          this.error = setErrorFromAxiosError(responseError);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
